import React, {useRef} from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './SuccessTab.css';
import Btn from '../../../button/btn/Btn';
import {TabType} from '../../types';
import sanitizeHtml from '../../../../library/sanitizeHtml';
import CustomScrollbar from '../../../customScrollbar/CustomScrollbar';

interface SuccessTabProps {
    currentTab: TabType;
    amount: number;
    messageContent: string;
    close: () => void;
    trialRecipients?: string[];
}

function SuccessTab({currentTab, amount, messageContent, close, trialRecipients}: SuccessTabProps) {
    const {t} = useTranslation('mailing');
    const isTrial = trialRecipients && trialRecipients.length > 0;
    const refContent = useRef(null);

    const getRecipientsText = () => {
        if(isTrial) {
            return trialRecipients.join(', ');
        }
        return amount.toString();
    };

    return (
        <>
            <css.header />
            <CustomScrollbar contentRef={refContent} cssStyle={''} maxBottom={65} />
            <css.container ref={refContent}> 
                <css.title>
                    {isTrial 
                        ? t('trialSuccessMessage', {recipients: getRecipientsText(), type: t(currentTab)} as any)
                        : t('sendSuccessMessage', {amount: amount, type: t(currentTab)} as any)
                    }
                </css.title>
                <css.messageText>
                    <css.messageLine dangerouslySetInnerHTML={sanitizeHtml(messageContent)} />
                </css.messageText>
            </css.container>
            <css.buttons>
                <Btn onClick={close}>
                    {t('close')}
                </Btn>
            </css.buttons>
        </>
    );
}

export default SuccessTab;
